<template>
  <!--  white logo -->
  <NuxtLink to="/">
    <img
      src="//summitproedu.imgix.net/summit-logo-white.png?w=145"
      alt="Summit Professional Education"
    />
  </NuxtLink>
</template>
